module.exports = __webpack_public_path__ + "img/mcot_logo.0c2a85de.png";